// extracted by mini-css-extract-plugin
module.exports = {"garderobo":"ScreenSimilar_garderobo__2r9FB"};